$("document").ready(function() {
  $(".tab-header-blocks .tab-heading").on("click",function() {
      $(".tab-header-blocks .tab-heading").removeClass("active");
    $(this).addClass("active");
    var indexVal=$(this).attr("data-index");
    $(".tab-content-block").hide();
    $(".tab-content-block[data-id='"+indexVal+"']").show();
  });


 /* Slick slider  for related product*/
  setTimeout(function(){
  $('.mobile-productslider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
   autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint:767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                    infinite: true,
                    dots: true
                }
        }
    ]
});
  }, 3000);

  /* Pdp Popup Slider */
$('.popup-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
   centerMode: false,
slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
        
      }
    }
  ]
  
});
  $('li.product__media-item').click(function(){ 
$('.product-media-popups .slick-list').css('opacity', 0);
    var slideno = $(this).data('media-cst-id');
    $('.product-media-popups img').each(function(){
        var imgthis = $(this);
        var imgid = $(this).data('media_cst-id');
        if(imgid == slideno){
          var slideto = imgthis.data('slick-index');
          $('.product-media-popups').slick('slickGoTo', slideto );
          
        }
    });
    setTimeout(function() {
    $('.product-media-popups .slick-list').css('opacity', 1);
      }, 150);
});
 /* article slider */
  $('.article-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
	
/* Faq Page Accordion Js */
 $(".faq-ques").click(function() {
    if ($('.faq-answer').is(':visible')) {
      $(".faq-answer").slideUp('slow');
     $(".faqinner-items").removeClass("active");
    }
    if ($(this).next(".faq-answer").is(':visible')) {
      $(this).next(".faq-answer").slideUp('slow');
       $(this).closest(".faqinner-items").removeClass("active");
    } else {
      $(this).next(".faq-answer").slideDown('slow');
       $(this).closest(".faqinner-items").addClass("active");
    }
  });

  /* Load More Ajax collection */
 
  let triggered = !1;

    $(document).on('click', '.view-all .view_all_btn' ,function (ev) {
    ev.preventDefault();
  var e = $(this).last(),
        t = e.attr("href");
    let triggered = !1;

var e = $(this).last(),
        t = e.attr("href");
     $.ajax({
        url: t,
        type: "GET",
        beforeSend: function() {
            e.find(".load").removeClass("hidden")
        }
    }).done(function(data) {
      var find_closest= e.closest(".btn-view");
        find_closest.remove();
     
       var find_html=$(data).find(".final-result").html();
       var find_div= $(data).find(".final-result").find(".view_all_btn");
        var r = document.createElement("li");
     find_div.hide();
         $(".final-result").append(find_html);
       
    })

    });
 
  /* popup Modal  jquery */
 $(".product-media-modal__content").on("click",function(){
   $(this).closest(".product-media-modal").addClass("open-pupmodal"); 
   $(this).closest(".product-media-modal").attr("open"); 
   $("body").addClass("overflow-hiddens");
 $(this).closest(".product-media-popups").find(".active").toggleClass("zoom-imgss");
 });
  $(".product-popup-image").each(function() {
    $(this).on("click", function(){
   
   $(this).toggleClass("zoom-imgs")
    });
});
  

/* Close Modal Btn */
 
  $(".close-pdp-btn").on("click",function(){
   $(this).closest(".product-media-modal").removeClass("open-pupmodal"); 
   $(".product-media-modal").attr("open"); 
   $("body").removeClass("overflow-hidden");
 });

/* collection filter */
  $(".collection-filter-link .list-menu__item").on("click",function(e) {
    e.preventDefault();
    $(".collection-list-item").removeClass("active");
    $(this).find(".collection-list-item").addClass("active");
    $(".collection-filter-link li input").prop('checked', false);
   $(this).find(".collection-list-item").prop('checked', true)
     var collection_handle= $(this).find(".collection-list-item").val();
    var collection_url= collection_handle;
     var parts = collection_url.split("/");
    var last_part = parts[parts.length-1];
    history.pushState('', '', "/collections/"+last_part);
     $.ajax({
     url: collection_handle,
     type:'GET',
     success: function(result){
       
     var col_result = $(result).find('.final-result').html();
      var col_count = $(result).find('.final-result').attr("data-count");
       $(".dropdown-box-filter").removeAttr("open");
      $(".final-result").html(col_result);
       $("#ProductCountDesktop").text(col_count+ "  Products");
     }
  });  
    
    
  })

});